export interface IVoiceLogin {
    sessionId: string;
    isSuccess: boolean;
    data: IVoiceLoginData[];
}

export interface IVoiceLoginData {
    username: string;
    secret: string;
}

export const DefaultVoiceLogin: IVoiceLogin = {
    sessionId: '',
    isSuccess: false,
    data: [],
};
